import React from 'react';
export function Footer() {
  return <footer className="bg-brown py-10 border-t border-white/10" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-43">
        <img src="https://cdn.magicpatterns.com/uploads/nvcxggdRAb1MpybQfVMZFq/camp-badge.png" alt="Camp ALKEBULAN Badge" className="w-12 h-12 object-contain mb-6 opacity-80 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-44" />

        <p className="text-cream/80 text-sm md:text-base mb-2" data-id="element-45">
          &copy; {new Date().getFullYear()} Camp ALKEBULAN. All rights reserved.
        </p>

        <p className="text-gold/70 text-xs md:text-sm tracking-wide uppercase" data-id="element-46">
          Built by QuikNation
        </p>
      </div>
    </footer>;
}